import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppLayout from '@/layouts';
import Routes from '@/routes';
import Login from '@/routes/auth/Login';
import ResetPassword from '@/routes/auth/ResetPassword';
import { Spin } from 'antd';
import Helmet from 'react-helmet';
import AppLocale from '@/lang';
import { IntlProvider } from 'react-intl';
import { getAuthUser } from '@/redux/actions/authActions';
import { getConfig } from '@/redux/actions/configActions';

class MainApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }
    async componentDidMount() {
        try {
            await this.props.getAuthUser();
            await this.props.getConfig();
            this.setState({ isLoading: false });

        } catch (err) {
            this.setState({ isLoading: false });
        }
    }

    render() {
        var { isLoading } = this.state;
        var { pathname } = this.props.location;
        const currentAppLocale = AppLocale['en'];

        const AppContainer = AppLayout;

        if (isLoading) {
            return (
                <div className="mt-4 text-center" style={{ position: 'absolute', top: '50%', left: '50%' }}>
                    <Spin size="large" />
                </div >
            )
        }

        var title = 'CHINGO DENTAL';

        switch (pathname) {
            case '/login': {
                return (
                    <Login />
                );
            }
            case '/reset-password': {
                return (
                    <ResetPassword />
                );
            }
            default: {
                return (
                    <IntlProvider
                        locale={'en'}
                        messages={currentAppLocale.messages}
                    >
                        <AppContainer>
                            <Helmet>
                                <title>{title}</title>
                            </Helmet>
                            <Routes />
                        </AppContainer>
                    </IntlProvider>
                )
            }
        }

    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser,
        config: state.config
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAuthUser: () => dispatch(getAuthUser()),
        getConfig: () => dispatch(getConfig())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainApp));